<section class="section banner">
  <div [@bannerTrigger] class="container">
    <div class="section-box-banner">
      <div class="content">
        <div>
          <h1>Hello! Salaam! My name is</h1>
        </div>
        <div class="banner-title">
          <h2>MUHAMMAD ABUBAKAR.</h2>
          <h4 class="subtitle">
            Frontend Developer | WordPress Expert | Angular Specialist
          </h4>
        </div>
        <div class="banner-description">
          <div class="mt-4">
            Crafting dynamic and user-focused digital solutions with Angular,
            Ionic, and WordPress expertise.
          </div>
        </div>
      </div>
      <div class="div-btn-banner">
        <a
          href="mailto:mabubakarinbox@gmail.com"
          target="_black"
          class="main-btn"
        >
          Hit me up!
        </a>
      </div>
    </div>
  </div>
</section>
